/**
 * POI types for an investment (source: "2026_07 Tagi POI Inwestycje v2.csv", `poi` column).
 * Hardcoded for now — BE (US-616.1) will own this later.
 */
export enum OfferPoiType {
    METRO = "stacja_metra",
    KOLEJ = "stacja_kolejowa",
    BUS = "przystanek_autobusowy",
    TRAM = "przystanek_tramwaju",
    PARK = "park",
    LAS = "las",
    REZERWAT = "rezerwat_przyrody"
}
/**
 * POI types for an investment (source: "2026_07 Tagi POI Inwestycje v2.csv", `poi` column).
 * Hardcoded for now — BE (US-616.1) will own this later.
 */
export enum OfferPoiType {
    METRO = "stacja_metra",
    KOLEJ = "stacja_kolejowa",
    BUS = "przystanek_autobusowy",
    TRAM = "przystanek_tramwaju",
    PARK = "park",
    LAS = "las",
    REZERWAT = "rezerwat_przyrody"
}
